import { LitElement, html } from 'lit';

import sortAlerts from './alerts-sort';

import translate from '../../utils/webcomponents/translate';
import { getAll } from './alert-api';
import alertEvents from './alert-events';

class AlertsOverview extends LitElement {
	static get properties() {
		return {
			hasLoaded: { type: Boolean },
			isLoading: { type: Boolean },
			isError: { type: Boolean },
			items: { type: Array },
		};
	}

	constructor() {
		super();

		this.items = [];

		this.hasLoaded = false;
		this.isLoading = false;
		this.isError = false;
	}

	connectedCallback() {
		super.connectedCallback();

		this.emptyMessageContainer = document.body.querySelector('.js-empty-message');

		document.body.addEventListener(alertEvents.CHANGED, () => this.onAlertsChanged());
		document.body.addEventListener(alertEvents.REMOVE_SUCCESS, (e) => this.onItemRemovedSuccess(e));

		this.load();
	}

	onAlertsChanged() {
		this.load();
	}

	onItemRemovedSuccess({ detail: removedItem = {} }) {
		const existingItems = this.items.filter((i) => i.alertConditionId !== removedItem.alertConditionId);

		this.items = [...existingItems];
	}

	async load() {
		this.isLoading = true;
		this.isError = false;

		try {
			const items = await getAll();

			this.items = sortAlerts(items);

			const isEmpty = this.items.length === 0;

			this.emptyMessageContainer.classList.toggle('is-hidden', !isEmpty);
		} catch (e) {
			this.isError = true;
		} finally {
			this.hasLoaded = true;
			this.isLoading = false;
		}
	}

	render() {
		if (this.isError) {
			return this.renderError();
		}

		return this.renderOverview();
	}

	renderError() {
		const errorFeedback = translate('alerts', 'somethingWentWrong', 'Something went wrong. Please try again.');
		const labelRetry = translate('alerts', 'retry', 'Retry');

		return html`
			<div class="trailer">
				<x-message
					modifier="error"
					icon="warning"
					message="${errorFeedback}"
				></x-message>
				<button
					class="button"
					@click="${this.load}"
				>
					${labelRetry}
				</button>
			</div>
		`;
	}

	renderOverview() {
		const loader = this.renderLoader();
		const table = this.renderTable();

		return html`${loader} ${table}`;
	}

	renderLoader() {
		return this.isLoading ? html`<x-loader .isLoading="${this.isLoading}"></x-loader>` : html``;
	}

	renderTable() {
		return html`<x-alerts-table .items="${this.items}"></x-alerts-table>`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-alerts-overview', AlertsOverview);

export default AlertsOverview;
